import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { StuVoteStatus, StuVoteStatusMap } from "API/vote";

interface StatusProps {
    status: StuVoteStatus;
}

export default function Status({ status }: StatusProps) {
    return (
        <span className={classNames(style.root, style[`state${status}`])}>
            {StuVoteStatusMap[status]}
        </span>
    );
}
